import { NgForm } from '@angular/forms/src/directives/ng_form';
import { Component, OnInit, Input } from '@angular/core';
//Formularios
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
//Enrutamiento
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
//Datalist
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
//Alertas sweetAlert
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { empty } from 'rxjs/Observer';
//Servicios
import { ConfigService } from '../../servicios/config/config.service';
import { AlertapqrService } from '../../servicios/pqr/alertapqr.service';
import { FichasTecnicasService } from '../../servicios/fichas-tecnicas/fichas-tecnicas.service';
import { HeaderService } from '../../servicios/header/header.service';
import { LogoEmpresaService } from '../../servicios/logo-empresa/logo-empresa.service';
import { PerfilesService } from '../../servicios/perfiles/perfiles.service';
import { UsuariosService } from '../../servicios/usuarios/usuarios.service';
import { PqrService } from '../../servicios/pqr/pqr.service';
import { ValidService } from '../../servicios/valid.service';

//Declaracion de variable global para usar jQuery
declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers:[
    FichasTecnicasService,
    PqrService
  ]
})
export class HeaderComponent implements OnInit {
  validaPeticion    : any = 0;
  intentos          = 0;
  lateral           : boolean = false;
  formFiltros       : FormGroup; //Accion para  Editar componente
  formCambioPass    : FormGroup;
  listpermisos      : any;
  mostrarpreloader  : any = 1;

  label_logout    = 'Salir';
  label_salir     = 'Salir del sistema';
  label_usuarios  = 'Usuarios';
  label_perfiles  = 'Perfiles';

  //Obtener los datos del Usuario
  nombreUsuario : any = localStorage.getItem('nombreUsuario');
  usuarioid     : any = localStorage.getItem('usuarioid');
  cedulaUsuario : any = localStorage.getItem('cedulaUsuario');
  idusuario     : any = localStorage.getItem('idusuario');
  idperfil      : any = localStorage.getItem('idperfil');
  tipousuario   : any = localStorage.getItem('tipousuario');
  nombreEmpresa : any = localStorage.getItem('nombreEmpresa');
  nitEmpresa    : any = localStorage.getItem('nitEmpresa');

  //Datos de conexion
  datahost      : any = localStorage.getItem('conexionhost');
  database      : any = localStorage.getItem('conexionbasedatos');
  datauser      : any = localStorage.getItem('conexionusuario');
  datapass      : any = localStorage.getItem('conexionclave');
  dataconexion = {
    'datahost' : this.datahost,
    'database' : this.database,
    'datauser' : this.datauser,
    'datapass' : this.datapass
  };

  PATH : any = localStorage.getItem('PATH');

  //Variables para notificaciones
  notificaciones              = new Array();
  cantidadNotificaiones       : any = 0;
  cantidadNotificaionesfichas : any = 0;
  listLogo                    : any [];

  //DATALIS: Declaracion de variables
  statesModulo            = new Array();
  selectedOptionModulo    : any;
  noResultModulo          = false;
  filtros                 = { modulo : '' }
  modulos                 = new Array();  //Almacena el arreglo de todos los modulos de sistema
  ArrayconsultaOperacion  = new Array();
  fichatecnica : any; //valida parametro tabla montaje ficha tecnica

  dataPasswordUsuario = {
    usuarioid    : '',
    nombreusuario: '',
    passactual   : '',
    nuevopasss   : '',
    confirmapass : ''
  }

  constructor(
    private _valid     : ValidService,
    private route      : ActivatedRoute,
    private router     : Router,
    private http       : Http,
    private _config    : ConfigService,
    private _alertapqr : AlertapqrService,
    private toastr     : ToastrService,
    private _header    : HeaderService,
    private _logos     : LogoEmpresaService,
    private _perfiles  : PerfilesService,
    private _fichas    : FichasTecnicasService,
    private _usuarios  : UsuariosService,
    private _pqr       : PqrService
  ) {}

  ngOnInit(){
    this.filtrosModulo();
    this.getPermisos();
  }

  dataIncial(){
    this.conexion(this.dataconexion);
    this.modulos = this._header.modulos;
    this.obtenerLogos();
    this.moduloFiltro();
    this.paramCampos();
    this.validaorCabecera();

    /**
     * Bloque que permite actualizar constantemente las notificaciones
     * enviadas a los coordinadores al momento de crear una incidencia.
     * JMM-2018-08-16
    */
    let count = 0;
    const interval = window.setInterval(() => {
      count++;
      if (count >= 1) {
        this.consultaOperacion();
      }
    }, 30000);
  }


   /**
   * Obtener parametros de la tabla montaje para viualizar campos
   * JMM-2018-10-04
   */
  paramCampos(){
    //Obtener parametros
    this._pqr.paramCampos().subscribe((resp)=>{
      if (resp.data) {
        this.fichatecnica = resp.data.fichatecnica;
      }
    });
  }

  /**
   * Función para hacer la conexión dinamica a la base de datos
   * JMM-2019-03-18
   */
  conexion(dataconexion){
    this._header.conexionService(dataconexion).subscribe((resp)=>{
    });
  }

  /**
   * Permite validar si el dominio a cambiado y lo regresa al login
   * CESAR ARIAS -2019-03-19
   */
  validaorCabecera(){
    if (this.PATH != this._config.obtenerPath()) {
      localStorage.removeItem('PATH');
      localStorage.removeItem('usuarioid');
      localStorage.removeItem('clave');
      localStorage.removeItem('nombreUsuario');
      localStorage.removeItem('cedulaUsuario');
      localStorage.removeItem('idusuario');
      localStorage.removeItem('idperfil');
      localStorage.removeItem('estadonotificacion');
      localStorage.removeItem('nombreEmpresa');
      localStorage.removeItem('nitEmpresa');
      localStorage.removeItem('useringresoid');
      localStorage.removeItem('useringresoestado');
      localStorage.removeItem('paramdesplazamiento');
      localStorage.removeItem('sucursalcliente');
      localStorage.removeItem('proximafecha');
      localStorage.clear();
      this.router.navigate(['/login'], { replaceUrl: true });
      location.reload();
    }
  }

  /**
   * Permite desloguearse de la aplicación eliminando la sesión del usuario
   * JMM-2018-03-22
   */
  logout(){
    swal({
      title: '<div class="div_contenido_swal">Desea salir de la aplicación?</div>',
      text: "",
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'boton_confirm_swal',
      cancelButtonClass: 'boton_cancel_swal',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value){
        //Salir session del cliente
        this._usuarios.salirsessioncliente().subscribe((resp)=>{
          if (resp.error) {
              localStorage.removeItem('usuarioid');
              localStorage.removeItem('clave');
              localStorage.removeItem('nombreUsuario');
              localStorage.removeItem('cedulaUsuario');
              localStorage.removeItem('idusuario');
              localStorage.removeItem('idperfil');
              localStorage.removeItem('estadonotificacion');
              localStorage.removeItem('PATH');
              localStorage.removeItem('nombreEmpresa');
              localStorage.removeItem('nitEmpresa');
              localStorage.removeItem('useringresoid');
              localStorage.removeItem('useringresoestado');
              localStorage.removeItem('paramdesplazamiento');
              localStorage.removeItem('sucursalcliente');
              localStorage.removeItem('proximafecha');
              localStorage.clear();
              //Redireccionar al login
              this.router.navigate(['/login'], { replaceUrl: true });
              location.reload();
          }else{
            localStorage.removeItem('usuarioid');
            localStorage.removeItem('clave');
            localStorage.removeItem('nombreUsuario');
            localStorage.removeItem('cedulaUsuario');
            localStorage.removeItem('idusuario');
            localStorage.removeItem('idperfil');
            localStorage.removeItem('estadonotificacion');
            localStorage.removeItem('PATH');
            localStorage.removeItem('nombreEmpresa');
            localStorage.removeItem('nitEmpresa');
            localStorage.removeItem('useringresoid');
            localStorage.removeItem('useringresoestado');
            localStorage.removeItem('paramdesplazamiento');
            localStorage.removeItem('sucursalcliente');
            localStorage.removeItem('proximafecha');
            localStorage.clear();
            this.router.navigate(['/login'], { replaceUrl: true });
            location.reload();
          }
        });
      }
    });
  }

  validarPasswoord(){
    if (!this.formCambioPass.valid) {
      this._valid.touched(this.formCambioPass);
      this.toastr.error('Campos obligatorios *', 'Error', { timeOut: 3000 });
    }else{
      if(this.formCambioPass.value.nuevopasss == this.formCambioPass.value.confirmapass){
        this._alertapqr.updatePassword(this.formCambioPass.value).subscribe((resp)=>{
          if (resp.error) {
            this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
            this.intentos = this.intentos +1;
            if (this.intentos == 3) {
              localStorage.clear();
              this.router.navigate(['/login'], { replaceUrl: true });
              location.reload();
            }
          }else{
            this.toastr.success(resp.message, '', { timeOut: 3000 });
            $("#ModalClave").modal('hide');
            this.validaPeticion = 0;
          }
        });
      }else{
        this.toastr.error('Por favor verifique que la nueva contraseña sea igual a la de confirmación *', 'Error', { timeOut: 3000 });
      }
    }
  }

  cerrarModal(){
    this.validaPeticion = 0;
    $("#ModalClave").modal('hide');
  }

  /**
   * Permite obtener las notificaciones enviadas a los encargados del tratamiento
   * de las PQR
   * JMM-2018-07-31
   */
  obtenerNotificaciones(idusuario){
    if (this.usuarioid == 'prosof'){
      this._alertapqr.getAlertasPqrs().subscribe((resp) =>{
        if (resp.data) {
          this.notificaciones = [];
          for (let i in resp.data) {
            if (resp.data[i].cierre != '1' && resp.data[i].estado == 'A') {
              this.notificaciones.push(resp.data[i]);
            }
          }
          this.cantidadNotificaiones = this.notificaciones.length;
        }
      });
    }else{
      let data = {
        'idusuario'                                 : idusuario,
        'Sucursal_por_usuario'                      : this.listpermisos.especiales_verCliente_Sucursal_por_usuario,
        'permiso_vertodaslasincidencias'            : this.listpermisos.especiales_vertodaslasincidencias,
        'especiales_verCliente_Sucursal_por_usuario': this.listpermisos.especiales_verCliente_Sucursal_por_usuario,
        'vertodaslasincidencias_por_dependencia'    : this.listpermisos.especiales_vertodaslasincidencias_por_dependencia,
        'inc_por_usuario_creo'                      : this.listpermisos.especiales_vertodas_incidencias_reportadas_por_usuario,
        'idperfil'                                  : this.idperfil ? this.idperfil : null,
      }

      this._alertapqr.getlistadoalertas(data).subscribe((resp) => {
        if (resp.data) {
          this.notificaciones = resp.data;
          this.cantidadNotificaiones = this.notificaciones.length;
        }
      });
    }

    $('body').off('click', '#name1').on('click', '#name1', function() {$('.dropdown-menu1').toggle();});
    $('body').off('click', '#name2').on('click', '#name2', function() {$('.dropdown-menu2').toggle();});

    $(document).mousedown(function(){
      $('.dropdown-menu1').hide();
      $('.dropdown-menu2').hide();
    });
  }

  /**
   * Obtener el listado operciones para el semaforo para las alertas
   * CESAR-2019-06-06
   */
  consultaOperacion(){
    let validausuario = 0;
    if(this.usuarioid != 'prosof' && this.validaPeticion == 0){
      validausuario = 1;
    }

    this.obtenerNotificaciones(this.idusuario);

    this.ArrayconsultaOperacion = [];
    let data = {
      validausuario        : validausuario,
      idperfil             : this.idperfil,
      idusuario            : this.idusuario,
      Sucursal_por_usuario : this.listpermisos.especiales_verCliente_Sucursal_por_usuario
    }

    this._fichas.obtenerOperacionSemaforo(data).subscribe((resp)=>{
      if (resp.data[0].length > 0) {
        for (var i in resp.data[0]) {
          this.ArrayconsultaOperacion.push({
            'pqrid'          :resp.data[0][i].pqrid,
            'Placa'          :resp.data[0][i].Placa,
            'nombreequipo'   :resp.data[0][i].serial ? resp.data[0][i].nombreequipo + ' - Serial : ' + resp.data[0][i].serial : resp.data[0][i].nombreequipo,
            'itemequipoid'   :resp.data[0][i].itemequipoid,
            'TiempoOperacion':resp.data[0][i].TiempoOperacion,
            'Tiempo'         :resp.data[0][i].Tiempo,
            'nombrefamilia'  :resp.data[0][i].nombrefamilia,
            'operacion'      :resp.data[0][i].operacion ? resp.data[0][i].operacion : '--',
            'ultimafecha'    :resp.data[0][i].ultimafecha,
            'valorfrecuencia':resp.data[0][i].valorfrecuencia,
            'PROXIMA'        :resp.data[0][i].PROXIMA,
            'codigointerno'  :resp.data[0][i].codigointerno ? resp.data[0][i].codigointerno : '--',
            'vencimiento'    :resp.data[0][i].vencimiento
          });
        }
      }
      this.ArrayconsultaOperacion.sort(function(a,b){
        if(a.pqrid > b.pqrid){
          return 1;
        }

        if(a.pqrid < b.pqrid){
          return -1;
        }
        return 0;
      });
      this.cantidadNotificaionesfichas = this.ArrayconsultaOperacion.length;

      if(resp.data[1]){
        if(resp.data[1].reiniciaclave == 1){
          if(resp.data[1].fechaactual > resp.data[1].proximafecha){
            this.validaPeticion = 1;
            $('#ModalClave').modal('show');
            this.dataPasswordUsuario.nombreusuario = resp.data[1].nombre;
            this.dataPasswordUsuario.usuarioid     = resp.data[1].usuarioid;
            this.dataPasswordUsuario.passactual    = '';
          }
        }
      }
    });
  }

  /**
   * Permite obtener el logo
   */
  obtenerLogos(){
    this._logos.cargarLogos().subscribe((res)=>{
      for(let i in res.data){
        if(res.data[i].estado == 'A'){
          this.listLogo = res.data[i].logo;
        }
      }
    });
  }

  /**
   * Permite obtener los permisos y perfiles de usuario
   * JMM-2018-12-12
   */
  getPermisos(){
    this._perfiles.getPermisosUsuariosFull().subscribe((resp)=>{
      if (resp.data) {
        this.mostrarpreloader = 0;
        this.listpermisos     = resp.data;
        this.dataIncial();
        this._usuarios.getUserIngresado();
        this.obtenerNotificaciones(this.idusuario);
      } else {
        this.mostrarpreloader = 1;
      }
    });
  }

  /**
   * Redireccionar enlace
   * JMM-2019-01-24
   */
  redireccionarEnlace(pqrid){
    this.router.navigate(['main/enrutamientos/enrutamientopqr/'+pqrid], { replaceUrl: true });
  }

  onSelectModulo(event: TypeaheadMatch): void { this.selectedOptionModulo = event.item.modulo;
    this._header.rutasModule(event.item.modulo,this.listpermisos);
    this.formFiltros.reset();
  }

  typeaheadNoResultsModulo(event: boolean): void { this.noResultModulo = event; }

  /**
   * Permite obtener el listado de modulo
   * CAAA-2019-03-08
   */
  moduloFiltro(){
    if (this.modulos.length > 0){
      this.statesModulo = [];
      var parametromodulo_aux = {};
      for (var i in this.modulos) {
        parametromodulo_aux[this.modulos[i]['modulo']] = this.modulos[i];
      }
      //DATALIST
      for (let i in parametromodulo_aux) {
        this.statesModulo.push({
          'modulo'     : parametromodulo_aux[i].modulo,
          'infomodulo' : parametromodulo_aux[i].modulo
        });
      }
    }
  }

  filtrosModulo(){
    this.formFiltros = new FormGroup({
      'modulo'    : new FormControl(this.filtros.modulo)
    });

    this.formCambioPass = new FormGroup({
      'usuarioid'     : new FormControl(this.dataPasswordUsuario.usuarioid, [Validators.required]),
      'nombreusuario' : new FormControl(this.dataPasswordUsuario.nombreusuario, [Validators.required]),
      'passactual'    : new FormControl(this.dataPasswordUsuario.passactual, [Validators.required]),
      'nuevopasss'    : new FormControl(this.dataPasswordUsuario.nuevopasss, [Validators.required]),
      'confirmapass'  : new FormControl(this.dataPasswordUsuario.confirmapass, [Validators.required]),
    });
  }
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/header/header.component.ts